import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  CardFooter
} from "reactstrap";
import ReactDOMServer from 'react-dom/server';
// react plugin used to create datetimepicker
import Datetime from "react-datetime";
// react plugin used to create switch buttons
import Switch from "react-bootstrap-switch";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
// react plugin that creates an input with badges
import TagsInput from "react-tagsinput";
// plugin that creates slider
import Slider from "nouislider";
import { Redirect } from "react-router-dom";

import { PanelHeader, ImageUpload, Progress, Button } from "components";
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import HomeVisitsList from "./HomeVisitsList";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import moment from "moment";
import "moment/locale/es";

const RegularMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={16}
      defaultCenter={{ lat: 39.653328, lng: -0.427402 }}
      defaultOptions={{
        scrollwheel: false
      }}
      center={{ lat: props.latitude, lng: props.longitude }}
      mapTypeId={"satellite"}
    >
      {props.latitude && (
        <Marker position={{ lat: props.latitude, lng: props.longitude }} />
      )}
    </GoogleMap>
  ))
);

var selectOptions = [
  { value: "one", label: "One" },
  { value: "two", label: "Two" },
  { value: "three", label: "Three" },
  { value: "four", label: "Four" },
  { value: "five", label: "Five" },
  { value: "six", label: "Six" }
];

class NewTicket extends React.Component {
  constructor(props) {
    super(props);
    let selectedCustomer = null;
    // let address = null;
    if (this.props.mainState.existingCustomerForTicket) {
      let prevCustomer = this.props.mainState.existingCustomerForTicket.customer;
      // console.log("existing customer", prevCustomer);
      selectedCustomer = {
        value: this.props.mainState.existingCustomerForTicket.id,
        label: prevCustomer.nombre_completo + " " + prevCustomer.primer_apellido + " " + prevCustomer.segundo_apellido + " (" + prevCustomer.nif + ")"
      };
      // address = prevCustomer.domicilio + ", " + prevCustomer.localidad;
    }
    // let isCreateFromCalendar = this.props.mainState.homeVisitFromCalendar;
    this.state = {
      isEdit: window.location.pathname.includes("citas/editar"),
      isEditingLoaded: false,
      selectedCustomer: selectedCustomer,
      multipleSelect: null,
      singleFileName: "",
      multipleFileName: "",
      singleFile: null,
      multipleFile: null,
      regularTags: ["pizza", "pasta", "parmesan"],
      searchQuery: null,
      lastSearchedQuery: null,
      lastLoadedCustomersSearch: null,
      technicians: null,
      goTo: null,
      // address: address ? address : (isCreateFromCalendar ? (isCreateFromCalendar.address ? isCreateFromCalendar.address : "") : ""),
      addressObject: null,
      // title: isCreateFromCalendar ? isCreateFromCalendar.title: "",
      // date_hour: isCreateFromCalendar ? isCreateFromCalendar.date : null,
      // date_day: isCreateFromCalendar ? isCreateFromCalendar.date : null,
      duration: 2
    };
    // if (this.state.isEdit) this.state.homeVisitId = parseInt(this.props.match.params.homeVisit);
    this.handleRegularTags = this.handleRegularTags.bind(this);
    this.handleFileInput = this.handleFileInput.bind(this);
    this.searchCustomerReference = this.searchCustomerReference.bind(this);
    this.getCustomerReferences = this.getCustomerReferences.bind(this);
    this.validateTicket = this.validateTicket.bind(this);
    this.createTicket = this.createTicket.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.goBack = this.goBack.bind(this);
    this.getTicketConcepts = this.getTicketConcepts.bind(this);
    this.getPendingInfo = this.getPendingInfo.bind(this);
  }
  componentDidMount() {
    this.props.get_ticket_options();
    // if (this.state.isEdit) this.props.getHomeVisit(this.state.homeVisitId);
    // var slider1 = this.refs.slider1;
    // var slider2 = this.refs.slider2;
    // Slider.create(slider1, {
    //   start: [40],
    //   connect: [true, false],
    //   step: 1,
    //   range: { min: 0, max: 100 }
    // });
    // Slider.create(slider2, {
    //   start: [20, 60],
    //   connect: [false, true, false],
    //   step: 1,
    //   range: { min: 0, max: 100 }
    // });
  }
  handleChangeAddress = address => {
    this.setState({ address });
  };
  handleSelectAddress = (address, placeId, suggestion) => {
    if (suggestion) {
      console.log(suggestion);
      this.setState({
        address: address,
        street: suggestion.formattedSuggestion.mainText,
        addressObject: suggestion,
        locality: suggestion.terms[suggestion.terms.length - 2].value
      });
      geocodeByAddress(address)
        .then(results => getLatLng(results[0]))
        .then(latLng => {
          console.log("Success", latLng);
          this.setState({
            latitude: latLng.lat,
            longitude: latLng.lng
          });
        })
        .catch(error => console.error("Error", error));
    } else {
      this.setState({
        address: address,
        street: "",
        addressObject: null,
        locality: "",
        latitude: null,
        longitude: null
      });
    }
  };
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  goBack() {
    window.history.back();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.lastLoadedCustomersSearch !== this.state.lastSearchedQuery) {
      if (this.state.lastSearchedQuery in this.props.mainState.customerSearchReference) {
        this.setState({ 
          customersReferences: this.props.mainState.customerSearchReference[this.state.lastSearchedQuery].references,
          lastLoadedCustomersSearch: this.state.lastSearchedQuery
        });
      }
    }
    if (prevProps.mainState.isCreatingTicket && !this.props.mainState.isCreatingTicket && !this.props.mainState.isErrorCreatingTicket) {
      // this.setState({ goTo: "/tickets" });
      this.redirectTo("/tickets/" + this.props.state.lastCreatedTicketID);
    }
    if (prevProps.mainState.isEditingTicket && !this.props.mainState.isEditingTicket && !this.props.mainState.isErrorEditingTicket) {
      this.redirectTo("/tickets/" + this.state.ticketId);
    }
    // if (this.state.isEdit && !this.state.isEditingLoaded) {
    //   if (this.props.state.homeVisits && this.props.state.homeVisits.byId) {
    //     let homeVisit = this.props.state.homeVisits.byId[this.state.homeVisitId][0];
    //     this.setState({
    //       isEditingLoaded: true,
    //       title: homeVisit.title,
    //       date_hour: moment(homeVisit.visit_date_hour, "hh:mm"),
    //       date_day: moment(homeVisit.visit_date_day, "DD/MM/YYYY"),
    //       address: homeVisit.visit_address + ", " + homeVisit.visit_locality,
    //       street: homeVisit.visit_address,
    //       longitude: homeVisit.longitude,
    //       latitude: homeVisit.latitude,
    //       description: homeVisit.description,
    //       visit_type: {
    //         value: parseInt(homeVisit.visit_type.tid),
    //         label: homeVisit.visit_type_name
    //       },
    //       locality: homeVisit.visit_locality,
    //       selectedCustomer: {
    //         value: parseInt(homeVisit.customer.id),
    //         label: homeVisit.customer.name
    //       },
    //       technicians: homeVisit.assigned_technician.map(technician => {
    //         return {
    //           value: technician.id,
    //           label: technician.username
    //         };
    //       })
    //     });
    //     console.log("homeVisit cargado", homeVisit);
    //   }
    // }
    // console.log("this.props.state", this.props.state);
  }
  handleRegularTags(regularTags) {
    this.setState({ regularTags });
  }
  // // // to understand the bellow functions please take a look at the end of the document as well
  // this handles the onFocus event over the normal / visible Inputs (reactstrap components)
  // that will trigger the on click of the non-visible inputs (normal html component)
  handleFileInput(e, type) {
    this.refs[type].click(e);
  }
  // this is the function triggered for the file type input
  // it will store inside the components state the names of the files and the files
  // after that, if you want to save the files you need to add a special on submit function for that
  // we haven't since we do not need to save the files - everything in our product is only front-end
  addFile(e, type) {
    let fileNames = "";
    let files = e.target.files;
    for (let i = 0; i < e.target.files.length; i++) {
      fileNames = fileNames + e.target.files[i].name;
      if (type === "multipleFile" && i !== e.target.files.length - 1) {
        fileNames = fileNames + ", ";
      }
    }
    this.setState({
      [type + "Name"]: fileNames,
      [type]: files
    });
  }
  searchCustomerReference() {
    this.props.userData.searchCustomerReference(this.state.searchQuery);
    this.setState({ lastSearchedQuery: this.state.searchQuery });
  }
  getCustomerReferences() {
    if (this.state.searchQuery === null || this.state.searchQuery === "") return null;
    if (this.state.searchQuery in this.props.mainState.customerSearchReference) {
      return this.props.mainState.customerSearchReference[this.state.searchQuery].references;
    } else {
      return null;
    }
  }
  validateTicket() {
    let result = true;
    if (!this.state.selectedCustomer) result = false;
    if (!this.state.description || (this.state.description && this.state.description.length < 2)) result = false;
    if (!this.state.priority) result = false;
    if (!this.state.concept) result = false;
    // if (!this.state.description) result = false;
    // console.log("##### STATE EN CHECK HOME VISIT ######");
    // console.log(this.state);

    return result;
  }
  getPendingInfo() {
    let result = [];
    if (!this.state.selectedCustomer) result.push(<span className="ticket-pending-info" key="falta-cliente">Falta el cliente</span>);
    if (!this.state.description || (this.state.description && this.state.description.length < 2)) result.push(<span className="ticket-pending-info" key="falta-descripcion">Explica la incidencia</span>);
    if (!this.state.priority) result.push(<span className="ticket-pending-info" key="falta-prioridad">Especifica prioridad</span>);
    if (!this.state.concept) result.push(<span className="ticket-pending-info" key="falta-concepto">Elige el concepto</span>);
    // if (!this.state.description) result = false;
    // console.log("##### STATE EN CHECK HOME VISIT ######");
    // console.log(this.state);

    let numero_error = 0;
    if (result.length > 0) {
      result = (
        <Col xs={12} key="error-list">
          <div><span>Faltan los siguientes datos:</span></div>
          <ul>
            {result.map(current => {
              numero_error++;
              return <li key={"error-datos-" + numero_error}>{current}</li>;
            })}
          </ul>
        </Col>
      );
    }

    return result;
  }
  createTicket() {
    if (this.validateTicket()) {
      let ticket = {
        customer: this.state.selectedCustomer.value,
        description: this.state.description,
        priority: parseInt(this.state.priority.value),
        concept: parseInt(this.state.concept.value)
      };
      console.log("NUEVO TICKET", ticket);
      this.props.createSupportTicket(ticket);
    }
  }
  editHomeVisit() {
    if (this.validateNewHomeVisit()) {
      let homeVisit = {
        id: this.state.homeVisitId,
        title: this.state.title,
        date: this.state.date_day.format("YYYY-MM-DD") + " " + this.state.date_hour.format("HH:mm"),
        description: this.state.description,
        visit_type: parseInt(this.state.visit_type.value),
        technicians: this.state.technicians,
        customer: this.state.selectedCustomer ? this.state.selectedCustomer.value : 635,
        locality: this.state.locality,
        street: this.state.street,
        latitude: this.state.latitude,
        longitude: this.state.longitude
      };
      console.log("EDITAR HOME VISIT");
      console.log(homeVisit);
      this.props.userData.editHomeVisit(homeVisit);
    }
  }
  prepareCustomersOptions(customersReferences) {
    if (!customersReferences) customersReferences = [];
    let nadunetCustomer = [
      {
        label: "nadunet (Trabajos propios)",
        value: 1
      }
    ];
    customersReferences = nadunetCustomer.concat(customersReferences);
    return customersReferences;
  }
  getTicketConcepts() {
    let result = [];
    // 72 is the vocabulary ID for Concepts
    let currentVocabularyID = "72";
    if (this.props.state.ticket_options) {
      if (currentVocabularyID in this.props.state.ticket_options) {
        if ("options" in this.props.state.ticket_options[currentVocabularyID]) {
          Object.keys(this.props.state.ticket_options[currentVocabularyID].options).map(option =>{
            option = this.props.state.ticket_options[currentVocabularyID].options[option];
            result.push({
              label: <span><span className={"ticket-concept-type type-" + option.type.name.toLowerCase()}>{option.type.name}</span>{option.name}</span>,
              value: option.id
            });
          });
        }
      }
    }
    return result;
  }
  buildTicketPriority(priority) {
    // console.log("state", state);
    let priority_id = parseInt(priority.id);
    let priority_name = priority.name;
    let priority_class = "";
    switch (priority_id) {
      case 110: // Baja
        priority_class = "baja";
        break;
      case 111: // Media
        priority_class = "media";
        break;
      case 112: // Alta
        priority_class = "alta";
        break;
      default:
        break;
    }

    let result = [];
    result.push(
      <div key={"circle-prio-" + priority.id} className={"circle-priority priority-" + priority_name.toLowerCase()}></div>
    );
    result.push(
      <span className={"priority" + " prio-" + priority_class} key={"priority-" + priority.id}>
        {priority_name}
      </span>
    );

    return result;
  }
  getTicketPriorities() {
    let result = [];
    // 30 is the vocabulary ID for Priorities
    let currentVocabularyID = "30";
    if (this.props.state.ticket_options) {
      if (currentVocabularyID in this.props.state.ticket_options) {
        if ("options" in this.props.state.ticket_options[currentVocabularyID]) {
          Object.keys(this.props.state.ticket_options[currentVocabularyID].options).map(option =>{
            option = this.props.state.ticket_options[currentVocabularyID].options[option];
            result.push({
              label: this.buildTicketPriority(option),
              value: option.id
            });
          });
        }
      }
    }
    return result;
  }
  customFilter(option, searchText) {
    let label = ReactDOMServer.renderToStaticMarkup(option.label).toLowerCase();
    let result = true;
    let words = searchText.split(" ");
    if (words.length === 0) return false;
    for (let index = 0; index < words.length; index++) {
      const element = words[index];
      element.replace(/\s/g, '');
      if (element && element !== "")
        result = result && label.includes(element.toLowerCase());
    }
    return result;
  }
  render() {
    if (this.state.goTo) {
      this.redirectTo(this.state.goTo);
      // return <Redirect to={this.state.goTo} />;
    }
    let save_text = "Abrir ticket";
    if (this.props.mainState.isCreatingTicket) save_text = "Abriendo ticket";
    let goBackButton = null;
    if (this.state.isEdit) {
      save_text = "Guardar cambios";
      goBackButton = (
        <Button
          color={"default"}
          round 
          // icon 
          // disabled={!this.validateNewHomeVisit()}
          onClick={() => {
            this.goBack();
          }}
        >
          Cancelar
        </Button>
      );
    }
    let pendingInfo = this.getPendingInfo();
    if (this.state.isEdit && !this.state.isEditingLoaded) {
      return (
        <div>
            <PanelHeader size="sm" />
            <div className="content text-center">
            <Card color="primary" style={{ margin: 0 }}>
                <CardHeader></CardHeader>
                <CardBody className="text-center">
                <div>
                    <div className="text-center">
                    <br />
                    <h5><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando</h5>
                    </div>
                </div>
                </CardBody>
                <CardFooter></CardFooter>
            </Card>
            </div>
        </div>
      );
    } else {
      return (
        <div>
          <PanelHeader size="sm" />
          <div className="content">
            <Row>
              <Col xs={12} md={6}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Cliente</CardTitle>
                  </CardHeader>
                  <CardBody className="form-inline">
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                          <Input type="text" 
                            placeholder="Buscar cliente..."
                            value={this.state.searchQuery || ""}
                            onChange={(e) => this.setState({searchQuery: e.target.value})}
                            onKeyDown={e => {
                              //console.log(e.keyCode);
                              if(e.keyCode == 13){
                                //Enter is key code 13
                                this.searchCustomerReference();
                                // put the login here
                              }
                            }}
                            style={{marginRight:"10px"}}
                          />
                          <Button
                            color={
                              this.props.mainState.isSearchingBills
                                ? "default"
                                : "primary"
                            }
                            round 
                            icon 
                            disabled={(this.state.searchQuery === null || this.state.searchQuery === "")}
                            onClick={this.searchCustomerReference}>
                            <i className={this.props.mainState.isSearchingHomeVisits?
                                                  "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_zoom-bold"} />
                          </Button>
                        </FormGroup>
                      </Col>
                      <Col xs={12}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Elegir cliente"
                          name="selectedCustomer"
                          value={this.state.selectedCustomer}
                          options={this.prepareCustomersOptions(this.state.customersReferences)}
                          noOptionsMessage={() => this.state.lastSearchedQuery ? <span>No hay resultados para <b>{this.state.searchQuery}</b></span> : "Busca clientes antes"}
                          onChange={value =>{
                            console.log("######## CAMBIO CLIENTE ######");
                            console.log(value);
                            this.setState({ selectedCustomer: value });
                          }}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <CardTitle tag="h4">¿Cuál es el motivo?</CardTitle>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Card>
                  {/* <CardHeader>
                    <CardTitle tag="h4">Día</CardTitle>
                  </CardHeader> */}
                  <CardBody>
                    <FormGroup>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Seleccionar concepto"
                        name="visit_type"
                        value={this.state.concept}
                        options={this.getTicketConcepts()}
                        noOptionsMessage={() => "Cargando conceptos"}
                        onChange={value =>
                          this.setState({ concept: value })
                        }
                        filterOption={this.customFilter}
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <CardTitle tag="h4">¿Es urgente? Elige una prioridad</CardTitle>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Card>
                  {/* <CardHeader>
                    <CardTitle tag="h4">Día</CardTitle>
                  </CardHeader> */}
                  <CardBody className="priority-options">
                    <FormGroup>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Seleccionar prioridad"
                        name="visit_type"
                        value={this.state.priority}
                        options={this.getTicketPriorities()}
                        noOptionsMessage={() => "Cargando prioridades"}
                        onChange={value =>
                          this.setState({ priority: value })
                        }
                        filterOption={this.customFilter}
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                  <CardTitle tag="h4">Detalles de la cita</CardTitle>
              </Col>
            </Row>
            <Row>
              <Col md={12} xs={12}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col xs={12} md={6}>
                        <CardTitle tag="h4">Descripción</CardTitle>
                          <br />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              {pendingInfo}
              <Button
                color={"primary"}
                round 
                // icon 
                disabled={!this.validateTicket() || this.props.mainState.isCreatingTicket}
                onClick={() => {
                  if (this.state.isEdit) {
                    this.editHomeVisit();
                  } else {
                    this.createTicket();
                  }
                }}
              >
                <i className={this.props.mainState.isCreatingTicket?
                  "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_simple-add"} />
                {" " + save_text}
              </Button>
              {goBackButton}
            </Row>
          </div>
        </div>
      );
    }
  }
}

export default NewTicket;



// WEBPACK FOOTER //
// ./src/views/Tickets/NewTicket.jsx